import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { PlannedExpertiseBottomBarRecap } from '../../_props'

/**
 * Provides the summary information displayed in the bottom bar
 * (patient name, required specialist, workflow label, etc.).
 *
 * Two possible sources, in order of priority:
 * 1. The `state` passed via React Router navigation (e.g., coming from the
 *    previous page, which already has this information available).
 * 2. The transmission data loaded from the API (`transmissionDetail`),
 *    used as a fallback if the user lands directly on this page (e.g., resuming
 *    a draft via a direct link, without navigation state).
 */
export function useWorkflowRecap(transmissionDetail: any) {
    const location = useLocation()
    const [recapData, setRecapData] = useState<PlannedExpertiseBottomBarRecap | null>(null)
    const locationStateRecap = location.state?.recap as PlannedExpertiseBottomBarRecap | null

    useEffect(() => {
        const stateRecap = location.state?.recap
        if (stateRecap) {
            setRecapData(stateRecap)
            return
        }
        if (transmissionDetail) {
            setRecapData({
                patientFullName: transmissionDetail.patient?.fullName ?? null,
                patientBirthdate: transmissionDetail.patient?.birthDate ?? null,
                patientSex: transmissionDetail.patient?.sex ?? null,
                requiredExpertLabel: transmissionDetail.requiredExpert?.fullName ?? null,
                workflowLabel: transmissionDetail.workflow?.name ?? null,
            })
        }
    }, [location.state, transmissionDetail])

    const recap = locationStateRecap ?? recapData

    if (!recap) return null

    return {
        ...recap,
        patientFullName: transmissionDetail?.patient?.fullName ?? recap.patientFullName,
    }
}
